import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contato">
      <header>
        <h2>Contactame!</h2>
        <p>Si ha percibido mi potencial o desea conversar conmigo, no dude en enviarme un mensaje. Será un placer poder ayudarlo o responder a sus consultas.</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:arrascaetaefdev@gmail.com">arrascaetaefdev@gmail.com</a>
        </div>
        <div>
          <img src={phoneIcon} alt="Email" />
          <a href="tel:+3512267600">+54(351) 226-7600</a>
        </div>  
      </div>
      {/* <Form></Form> */}
    </Container>
  )
}